import React from "react";

const AboutUs = () => {
    return (
      <div className="bg-gray-50 text-gray-800">
        {/* Header Section */}
        <header className="bg-blue-600 text-white text-center py-16">
          <h1 className="text-4xl font-bold">Welcome to The Hazer Global!</h1>
          <p className="mt-4 text-lg">Transforming the Construction Industry with Convenience, Innovation, and Trust</p>
        </header>
  
        {/* Company Overview */}
        <section className="py-12 px-6 md:px-16">
          <h2 className="text-3xl font-bold text-center mb-6">Our Story</h2>
          <p className="text-lg leading-7">
            The Hazer Global was born from a vision to revolutionize the construction industry. After a decade of research, innovation, and dedication, we've created a groundbreaking online platform that converges technology and societal needs.
          </p>
          <div className="mt-6 grid gap-6 md:grid-cols-2">
            <div className="p-6 bg-gray-200 shadow rounded-lg relative overflow-hidden border border-[#ff9906]">
                <div className="absolute top-0 left-0 w-4 h-4 bg-[#ff9906] rounded-tr-lg"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 bg-[#ff9906] rounded-tl-lg"></div>
                <h3 className="text-xl font-semibold">Job Opportunities</h3>
                <p className="mt-2">Handymen can effortlessly find and secure jobs, leveraging their expertise.</p>
            </div>
            <div className="p-6 bg-gray-200 shadow rounded-lg relative overflow-hidden border border-[#ff9906]">
                <div className="absolute top-0 left-0 w-4 h-4 bg-[#ff9906] rounded-tr-lg"></div>
                <div className="absolute bottom-0 right-0 w-4 h-4 bg-[#ff9906] rounded-tl-lg"></div>
                <h3 className="text-xl font-semibold">Convenience</h3>
                <p className="mt-2">Homeowners and businesses can effortlessly post projects, receive quotes, and hire trusted professionals.</p>
            </div>
           </div>

        </section>
  
        {/* Mission, Vision, and Values */}
        <section className="bg-gray-200 py-12 px-6 md:px-16">
          <h2 className="text-3xl font-bold text-center mb-6">Our Mission, Vision & Core Values</h2>
          <div className="grid gap-6 md:grid-cols-3">
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Mission</h3>
              <p className="mt-2">Connecting you with the right experts, at the right time.</p>
            </div>
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Vision</h3>
              <p className="mt-2">Unlocking a brighter future through seamless connections and limitless opportunities.</p>
            </div>
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Core Values</h3>
              <p className="mt-2">Empathy, Purpose, Collaboration, Integrity, and Empowerment.</p>
            </div>
          </div>
        </section>
  
        {/* What We Offer */}
        <section className="py-12 px-6 md:px-16">
          <h2 className="text-3xl font-bold text-center mb-6">What We Offer</h2>
          <div className="grid gap-6 md:grid-cols-3">
            <div className="p-6 bg-gray-300 shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Handyman Services</h3>
              <p className="mt-2">Expert solutions for all your domestic and commercial needs.</p>
            </div>
            <div className="p-6 bg-gray-300 shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Marketplace</h3>
              <p className="mt-2">A vast selection of construction materials and appliances at competitive prices.</p>
            </div>
            <div className="p-6 bg-gray-300 shadow-lg rounded-lg">
              <h3 className="text-xl font-semibold">Architectural Designs</h3>
              <p className="mt-2">Streamlined drafting, mapping, and estimation tools for your projects.</p>
            </div>
          </div>
        </section>
  
        {/* Team Introduction */}
        <section className="bg-gray-100 py-12 px-6 md:px-16">
        <div>
            <div className="container flex justify-center mx-auto pt-16">
                <div>
                    <p className="text-gray-500 text-lg text-center font-normal pb-3">BUILDING TEAM</p>
                    <h1 className="xl:text-4xl text-3xl text-center text-gray-800 font-extrabold pb-6 sm:w-4/6 w-5/6 mx-auto">The Talented People Behind the Scenes of the Organization</h1>
                </div>
            </div>
            <div className="w-full bg-gray-200 px-10 pt-10">
                <div className="container mx-auto">
                    <div className="lg:flex md:flex sm:flex items-center xl:justify-evenly flex-wrap md:justify-around sm:justify-around lg:justify-around">
                        <div className="bg-white shadow-lg xl:w-1/3 sm:w-3/4 md:w-2/5 relative mt-16 mb-32 sm:mb-24 xl:max-w-sm lg:w-2/5">
                            <div className="rounded overflow-hidden shadow-md bg-white">
                                <div className="absolute -mt-20 w-full flex justify-center">
                                    <div className="h-32 w-32">
                                        <img src="https://cdn.tuk.dev/assets/photo-1564061170517-d3907caa96ea.jfif" alt className="rounded-full object-cover h-full w-full shadow-md" />
                                    </div>
                                </div>
                                <div className="px-6 mt-16">
                                    <div className="font-bold text-3xl text-center pb-1">Khawar Hayyat</div>
                                    <p className="text-gray-800 text-sm text-center">Chief Executive Officer</p>
                                    <p className="text-center text-gray-600 text-base pt-3 font-normal">The CEO's role in raising a company's corporate IQ is to establish an atmosphere that promotes knowledge sharing and collaboration.</p>
                                    <div className="w-full flex justify-center pt-5 pb-5">
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-github">
                                                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-twitter">
                                                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-instagram">
                                                    <rect x={2} y={2} width={20} height={20} rx={5} ry={5} />
                                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                                                </svg>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-white shadow-lg xl:w-1/3 sm:w-3/4 md:w-2/5 relative mt-16 mb-32 sm:mb-24 xl:max-w-sm lg:w-2/5">
                            <div className="rounded overflow-hidden shadow-md bg-white">
                                <div className="absolute -mt-20 w-full flex justify-center">
                                    <div className="h-32 w-32">
                                        <img src="https://cdn.tuk.dev/assets/blond-man-happy-expression_1194-2873.jpg" alt className="rounded-full object-cover h-full w-full shadow-md" />
                                    </div>
                                </div>
                                <div className="px-6 mt-16">
                                    <div className="font-bold text-3xl text-center pb-1">Hafiz M Hamza</div>
                                    <p className="text-gray-800 text-sm text-center">{`CTO ( Cheif Technology Officer )`}</p>
                                    <p className="text-center text-gray-600 text-base pt-3 font-normal">The emphasis on innovation and technology in our companies has resulted in a few of them establishing global benchmarks in product design and development.</p>
                                    <div className="w-full flex justify-center pt-5 pb-5">
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-github">
                                                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-twitter">
                                                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                                                </svg>
                                            </div>
                                        </a>
                                        <a href="javascript:void(0)" className="mx-5">
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="#718096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-instagram">
                                                    <rect x={2} y={2} width={20} height={20} rx={5} ry={5} />
                                                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                                                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                                                </svg>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
        {/* Call to Action */}
        <section className="py-8 px-6 md:px-16 text-center">
          <h2 className="text-3xl font-bold mb-6">Get Started with The Hazer Global</h2>
          <div className="flex justify-center gap-4">
            <button className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow">Explore Our Platform</button>
            <button className="bg-[#ff9906] text-white px-6 py-3 rounded-lg shadow">Register as a Professional</button>
          </div>
        </section>
      </div>
    );
  };

export default AboutUs;
